module.exports = __webpack_public_path__ + "static/media/arrow-right.55413b31.svg";